import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Grid from '@mui/material/Grid2'

import { ProductSegmentCard } from '../cards/ProductSegmentCard';
import {
  transformTallyData,
  transformProductSegmentData,
  removeCardType,
  transformProductGroupedStack,
  colorCodes,
} from '../dash-util';
import { ProductCard } from '../cards/ProductCard';
import { Card } from '@mui/material';
import GroupedStackedColumn from '../charts/GroupedStackedColumn';

export function SalesView({ cardsData, regressionData, productData, periodFilter, setPeriodFilter }) {

  // console.log('SalesView: ', productData)
  const orderedCards = removeCardType(cardsData, 'Total OPEX')
    ?.sort((a, b) => a.value - b.value);

  const [excoGroupedStacked, setExcoGroupedStacked] = useState([]);
  const [showGroupedLegend, setShowGroupedLegend] = useState(false);

  useEffect(() => {
    const groupedStacked = transformProductGroupedStack(regressionData);
    setExcoGroupedStacked(groupedStacked);

    const showLegend = !groupedStacked.series.every((item) => item.data.length === 0);
    setShowGroupedLegend(showLegend);

  }, [cardsData, regressionData, productData, periodFilter]);

  return (
    <>
      <Grid container spacing={3}>

        {orderedCards?.length > 0
          ? orderedCards.map((d, index) => (
            <Grid size={{ lg: Math.max(3, 12/orderedCards?.length), sm: 6, xs: 12 }} key={d.type}>
              <ProductCard
                sx={{ height: '100%' }}
                data={transformTallyData(cardsData, d?.type, colorCodes[index])}
              />
            </Grid>
          )) :
          [...Array(4)].map((x, i) => (
            <Grid size={{ lg: 3, sm: 6, xs: 12 }} key={`sv-place-holder-${i}`}>
              <Card sx={{ height: '100%' }}>

              </Card>
            </Grid>
          ))
        }
      </Grid>

      <Grid container spacing={3} sx={{ mt: 3 }}>
        <Grid size={{ xs: 8 }} key="sv-grouped stacked">
          <GroupedStackedColumn
            series={excoGroupedStacked.series}
            categories={excoGroupedStacked.categories}
            height={350}
            title={"Product Sales"}
            periodFilter={periodFilter}
            setPeriodFilter={setPeriodFilter}
            showLegend={showGroupedLegend}
          />
        </Grid>

        <Grid size={{ xs: 4 }} key="sv-product segment">
          <ProductSegmentCard
            products={transformProductSegmentData(productData)}
            periodFilter={periodFilter}
            setPeriodFilter={setPeriodFilter}
            sx={{ height: '100%' }}
          />
        </Grid>
      </Grid>
    </>
  )
}

SalesView.propTypes = {
  cardData: PropTypes.arrayOf(PropTypes.object),
}
